import { AssignLearningToLearningDTO, LearningCompetenceSimpleTypeEnum, LearningCompetencesQueryParams, LearningCompetenceTypeEnum, StudyCycleEnum, StudyProgramApi, StudyProgramDTO, StudyProgramQueryParams, StudyProgramUpdateDTO } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new StudyProgramApi(getAuthConfiguration());

export const getStudyProgram = (id: string) => {
    if (!id) {
        return {} as StudyProgramDTO;
    }
    return ApiFactory().apiStudyProgramGetStudyProgramByIdIdGet({ id });
}

export const getFilterOptions = (studyCycle: StudyCycleEnum) => {
    return ApiFactory().apiStudyProgramGetFilterOptionsGet({studyCycle});
}

export const getStudyPrograms = (studyProgramQueryParams: StudyProgramQueryParams) => {
    
    return ApiFactory().apiStudyProgramGetAllStudyProgramsPost({studyProgramQueryParams});
}

export const getDuplicateDisciplinesReport = (studyProgramQueryParams: StudyProgramQueryParams) => {
    return ApiFactory().apiStudyProgramGetDuplicateDisciplinesReportPost({ studyProgramQueryParams });
}

export const getMissingTitularsReport = (studyProgramQueryParams: StudyProgramQueryParams) => {
    return ApiFactory().apiStudyProgramGetMissingTitularsReportPost({ studyProgramQueryParams });
}

export const getLearningOutcomesReport = (studyProgramQueryParams: StudyProgramQueryParams) => {
    return ApiFactory().apiStudyProgramGetLearningOutcomesReportPost({ studyProgramQueryParams });
}

export const getNonApprovedSubjectsReport =(studyProgramQueryParams: StudyProgramQueryParams) => {
    return ApiFactory().apiStudyProgramGetNonApprovedSubjectsReportPost({ studyProgramQueryParams });
}

export const addStudyProgram = (studyProgramUpdateDTO: StudyProgramUpdateDTO) => {
    return ApiFactory().apiStudyProgramAddStudyprogramPost({ studyProgramUpdateDTO });
}

export const updateStudyProgram = (id: string, studyProgramUpdateDTO: StudyProgramUpdateDTO) => { 
    return ApiFactory().apiStudyProgramUpdateStudyProgramIdPut({ id, studyProgramUpdateDTO });
}

export const deleteStudyProgram = (id: string) => {
    return ApiFactory().apiStudyProgramDeleteIdDelete({ id });
}

export const getLearningCompetences = ( learningCompetencesQueryParams: LearningCompetencesQueryParams) => {
    return ApiFactory().apiStudyProgramGetAllLearningCompetencesPost({ learningCompetencesQueryParams });
}

export const assignLearningsToCompetence = (assignLearningToLearningDTO: AssignLearningToLearningDTO) => {
  return ApiFactory().apiStudyProgramAssignLearningsToLearningPost({ assignLearningToLearningDTO });
};

export const deleteLearningCompetance = (id: string, force = false) => {
    return ApiFactory().apiStudyProgramDeleteLearningIdDelete({ id, force });
}